'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardList = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _CardList = require('./CardList.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardList = exports.CardList = function CardList(_ref) {
  var items = _ref.items,
      className = _ref.className,
      splitAfter = _ref.splitAfter;

  var presentedItems = items.map(function (item) {
    return _react2.default.createElement(
      'div',
      { className: 'cardItem', key: _shortid2.default.generate() },
      item
    );
  });

  return _react2.default.createElement(
    'div',
    { className: className + ' row cardCardList' },
    _react2.default.createElement(
      'div',
      { className: splitAfter ? 'col-xs-6' : 'col-xs-12' },
      splitAfter ? presentedItems.slice(0, splitAfter) : presentedItems
    ),
    splitAfter && _react2.default.createElement(
      'div',
      { className: 'col-xs-6' },
      presentedItems.slice(splitAfter)
    )
  );
};

CardList.propTypes = {
  /**
   * Array of nodes to be rendered in list
   */
  items: _propTypes2.default.array,
  /**
   * Glamorous classname
   */
  className: _propTypes2.default.string.isRequired,
  /**
   * After how many items should the second column start?
   */
  splitAfter: _propTypes2.default.number
};

exports.default = (0, _glamorous2.default)(CardList)(_CardList.defaultStyle, _CardList.mapPropsAndThemeToStyle);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/cards/Card/CardList/CardList.js
// module id = 453
// module chunks = 0